import { render, staticRenderFns } from "./PackageSummaryShipment.vue?vue&type=template&id=1503a225"
import script from "./PackageSummaryShipment.vue?vue&type=script&lang=ts"
export * from "./PackageSummaryShipment.vue?vue&type=script&lang=ts"
import style0 from "./PackageSummaryShipment.vue?vue&type=style&index=0&id=1503a225&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports